import { useState, useEffect } from 'react';
import {useBaseApi} from "../useBaseApi";

export function useProvinces() {

    const [provinces, setProvinces] = useState(null);
    const {get} = useBaseApi();

    useEffect( () => {
        load();
    }, []);

    const load = async () => {
        let response = await get("/province", false);
        setProvinces(response.data);
    }

    return [provinces];
}